import { render } from "./CreateKubernetesCluster.vue?vue&type=template&id=5affb547&scoped=true"
import script from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"

import "./CreateKubernetesCluster.vue?vue&type=style&index=0&id=5affb547&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5affb547"]])

export default __exports__